<template>
    <editor-content :editor="editor" />
</template>

<script>
import Mention from "@tiptap/extension-mention";
import StarterKit from "@tiptap/starter-kit";
import { Editor, EditorContent } from "@tiptap/vue-2";
import suggestion from "./suggestion.js";

export default {
    components: {
        EditorContent,
    },

    emits: ['input'],

    data() {
        return {
            editor: null,
        };
    },

    mounted() {

        document.addEventListener('cm:editor-onUpdate', (event) => this.$emit('input', event.detail));

        this.editor = new Editor({
            extensions: [
                StarterKit,
                Mention.configure({
                    HTMLAttributes: {
                        class: "mention",
                    },
                    suggestion,
                }),
            ],
            content: '',
            onUpdate({ editor }) {
                document.dispatchEvent(new CustomEvent('cm:editor-onUpdate', {
                    detail: editor.getHTML()
                }))
            },
        });
    },

    beforeUnmount() {
        this.editor.destroy();
    },
};
</script>

<style lang="scss">
/* Basic editor styles */
.tiptap {
    width: 100%;

    > * + * {
        margin-top: 0.75em;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        line-height: 1.1;
    }
}

.mention {
    padding: 0.1rem 0.3rem;
    box-decoration-break: clone;
    color: #348af3;
}

</style>
